// YERİ: src/app/domains/site/sections/edu-programs.section.ts
// Eğitim — Programlar / Kurslar grid'i (ikon + başlık + açıklama + süre/seviye etiketi).

import { inject, Component, computed, input } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';
import { SiteChromeText } from '../core/site-chrome-text';

interface Program { icon?: string; title: string; description?: string; meta?: string; }

@Component({
  selector: 'sec-edu-programs',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="programs" class="bg-white py-24 dark:bg-neutral-950">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl text-center">
          <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
          @if (subtitle()) { <p class="mt-4 text-lg text-neutral-600 dark:text-neutral-400">{{ subtitle() }}</p> }
        </div>
        <div class="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          @for (p of items(); track p.title) {
            <div class="group flex flex-col rounded-2xl border border-neutral-200 bg-white p-7 transition hover:-translate-y-1 hover:shadow-xl dark:border-neutral-800 dark:bg-neutral-900">
              <div class="flex size-12 items-center justify-center rounded-xl text-white" style="background-color:var(--site-primary)">
                <m-icon [name]="p.icon || 'book-open'" size="md" />
              </div>
              <h3 class="mt-5 text-lg font-semibold text-neutral-900 dark:text-white">{{ p.title }}</h3>
              @if (p.description) { <p class="mt-2 flex-auto text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">{{ p.description }}</p> }
              @if (p.meta) {
                <span class="mt-4 inline-flex w-fit items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-medium" style="background-color:color-mix(in srgb, var(--site-accent) 18%, transparent); color:var(--site-accent)">
                  <m-icon name="clock" size="xs" /> {{ p.meta }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class EduProgramsSection {
  protected text = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', this.text.t('fb.programlarimiz')));
  protected title = computed(() => cfg(this.config(), 'title', this.text.t('fb.egitimProgramlari')));
  protected subtitle = computed(() => cfg(this.config(), 'subtitle', this.text.t('fb.herYasVeSeviyeye')));
  protected items = computed<Program[]>(() => cfg<Program[]>(this.config(), 'items', [
    { icon: 'calculator', title: 'Matematik & Fen', description: this.text.t('fb.analitikDusunmeVeProblem'), meta: this.text.t('fb.tumSeviyeler') },
    { icon: 'languages', title: this.text.t('fb.yabanciDil'), description: this.text.t('fb.ingilizceAgirlikliKonusmaPratigi'), meta: 'A1–C1' },
    { icon: 'code', title: 'Kodlama & Robotik', description: this.text.t('fb.geleceginBecerileriYazilimAlgoritma'), meta: this.text.t('fb.8Yas') },
    { icon: 'palette', title: this.text.t('fb.sanatTasarim'), description: this.text.t('fb.yaraticiligiGelistirenGorselSanatlar'), meta: this.text.t('fb.tumYaslar') },
    { icon: 'music', title: this.text.t('fb.muzik'), description: this.text.t('fb.bireyselVeGrupEnstruman'), meta: this.text.t('fb.baslangicileri') },
    { icon: 'graduation-cap', title: this.text.t('fb.sinavaHazirlik'), description: this.text.t('fb.lgsVeYksIcin'), meta: 'Ortaokul–Lise' },
  ]));
}
